// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6d0ab108] .el-form-item__label {\n  width: 125px;\n  min-height: 32px;\n}\n[data-v-6d0ab108] .el-image {\n  margin: 0 10px 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
